import { actions } from '../../actions/actionTypes'

const initialState = {
  mongoDbId: null,
  requestId: '190920196ajkkxm8fg5idvcievkror7z5qd6vmq3naprs1f531wch3io4w',
  signedDocs: null,
  unsignedDocs: null,
  lastUpload: null
}

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.ARCHIVE_ID_RECEIVED:
      return {
        ...state,
        mongoDbId: action.payload
      }
    case actions.REQUEST_ID_RECEIVED:
      return {
        ...state,
        requestId: action.payload
      }
    case actions.GET_SIGNED_DOCS:
      return {
        ...state,
        signedDocs: action.payload
      }
    case actions.GET_UNSIGNED_DOCS:
      return {
        ...state,
        unsignedDocs: action.payload
      }
    case actions.UNSIGNED_DOC_EDIT_SUCCESSFUL: {
      if (!state.unsignedDocs) return state
      const newUnsignedDocs = [...state.unsignedDocs]
      const updatedIndex = newUnsignedDocs.findIndex(d => d._id === action.payload.id)
      if (updatedIndex !== -1) {
        newUnsignedDocs[updatedIndex] = action.payload.data

      }
      return {
        ...state,
        unsignedDocs: newUnsignedDocs
      }
    }
    case actions.UNSIGNED_DOC_DELETE_SUCCESSFUL: {
      if (!state.unsignedDocs) return state
      return {
        ...state,
        unsignedDocs: state.unsignedDocs.filter(d => d._id !== action.payload)
      }
    }
    case actions.SET_LAST_UPLOAD:
      return {
        ...state,
        lastUpload: action.payload
      }
    default:
      return state
  }
}

export default dataReducer
